<div class="malfunction-filter__section">
  <div class="malfunction-filter__title">{{ "Malfunction.FilterOnService" | translate }}</div>
  <div class="malfunction-filter__select-wrapper">
    <select class="malfunction-filter__select" [(ngModel)]="productType">
      <option value="" selected="selected">{{ "Chart.AllServices" | translate }}</option>
      @for (type of visibleProductTypes(); track type.value) {
        <option [value]="type.value">{{ type.labelKey | translate }}</option>
      }
    </select>
    <svg-icon src="assets/images/icons/select-arrows.svg"></svg-icon>
  </div>
  @if (productType() !== "") {
    <div class="malfunction-filter__select-wrapper">
      <select class="malfunction-filter__select" [(ngModel)]="subscription">
        <option value="" selected="selected">{{ allSubscriptionsLabelKey() | translate }}</option>
        @for (subscription of subscriptions(); track $index) {
          <option [ngValue]="subscription">
            {{ subscription.customerDescription || subscription.description }}
          </option>
        }
      </select>
      <svg-icon src="assets/images/icons/select-arrows.svg"></svg-icon>
    </div>
  }
</div>
